module.exports = __webpack_public_path__ + "media/components/home/masthead/img/space_1680x400-2cbee24fe0f1022a2558e3c5beb423ab.jpg";